import { useTranslation } from 'react-i18next'
import { PushTemplateData } from '../../../../types'
import { Alert, InfoTable, Tag } from '../../../../ui'
import VariableDisplay from '../../../../ui/form/VariableDisplay'

const deliveryOptions = [
    ['badge', 'push_badge'],
    ['sound', 'push_sound'],
    ['category', 'push_category'],
    ['collapse_key', 'push_collapse_key'],
    ['thread_id', 'push_thread'],
    ['priority', 'push_priority'],
    ['android_channel_id', 'push_android_channel'],
    ['tag', 'push_tag'],
] as const

export const PushTable = ({ data }: { data: PushTemplateData }) => {
    const { t } = useTranslation()
    const deliveryRows = Object.fromEntries(deliveryOptions
        .filter(([field]) => data[field] !== undefined && data[field] !== '')
        .map(([field, label]) => [t(label), <VariableDisplay key={field} value={String(data[field])} />]))
    const titleLimit = 50
    const bodyLimit = 150
    const titleLength = (data.title?.length ?? 0)
    const bodyLength = (data.body?.length ?? 0)

    return <>
        {titleLength > titleLimit && <Alert variant="warn" title={t('note')} body={t('push_title_length_limit', { count: titleLength })} />}
        {bodyLength > bodyLimit && <Alert variant="warn" title={t('note')} body={t('push_body_length_limit', { count: bodyLength })} />}
        <InfoTable rows={{
            [t('title')]: data.title
                ? <VariableDisplay value={data.title} />
                : <Tag variant="warn">{t('missing')}</Tag>,
            [t('body')]: data.body
                ? <VariableDisplay value={data.body} />
                : <Tag variant="warn">{t('missing')}</Tag>,
            [t('deeplink')]: data.url,
            [t('raw_json')]: JSON.stringify(data.custom),
            ...deliveryRows,
        }} />
    </>
}
